export const ADD_NAME: string = "ADD_NAME";
export const ADD_PICTURE: string = "ADD_PICTURE";
export const ADD_COMPANY_NAME: string = "ADD_COMPANY_NAME";
export const ADD_FULL_PROFILE: string = "ADD_FULL_PROFILE";

export function addName(name: string): IAddNameActionType {
    return { type: ADD_NAME, name: name};
}

export function addPicture(picture: string): IAddPictureActionType {
    return { type: ADD_PICTURE, picture:picture};
}

export function addCompanyName(campanyName: string): IAddCompanyNameActionType {
    return { type: ADD_COMPANY_NAME, campanyName: campanyName};
}

export function addFullProfile(profile: any): AddFullProfileActionType {
    return { type: ADD_FULL_PROFILE, profile: profile};
} 

export interface IAddNameActionType { type:string, name: string}
export interface IAddPictureActionType { type:string, picture:string }
export interface IAddCompanyNameActionType { type:string, campanyName: string}
export interface AddFullProfileActionType { type: string, profile: any}